<div class="modal-header">
    <h4>Attachment Options</h4>
</div>
<div class="modal-body">
    <label *ngIf="typeList['SMAttachmentType']?.length > 0">Attachment Type:</label>
    <div *ngIf="typeList['SMAttachmentType']?.length > 0">
        <div class="row" style="margin:5px;margin-bottom:15px;" *ngFor="let data of typeList['SMAttachmentType']; let i = index">
            <label class="col-12 btn btn-outline-dark checklist" [ngClass]="{'active' : formData.attachmentType == data.Code, 'inactiveAttach' : (formData.attachmentType != data.Code && formData.attachmentType != null)}">
                <input type="radio" value="{{data.Code}}" [(ngModel)]="formData.attachmentType" name="{{i}}" style="display:none;" />{{data.CodeDescription}}
            </label>
        </div>
    </div>
    <div *ngIf="attachmentCount == 1">
        <label>Attachment Description:</label>
        <input class="form-control" [(ngModel)]="formData.attachmentDescription" />
    </div>
</div>
<div class="modal-footer">
    <div class="row col-12" style="padding-right: 0px;padding-left: 0px;">
        <div class="col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4" *ngIf="!triggerDelete">
            <button class="btn btn-danger" type="button" (click)="triggerDeleteAttachment()" *ngIf="!triggerDelete && details != null">Delete</button>
        </div>
        <div class="col-8 col-xs-8 col-sm-8 col-md-8 col-lg-8" style="text-align: right;" *ngIf="!triggerDelete">
            <button class="btn btn-text-primary" type="button" (click)="cancelClicked()">Cancel</button>
            <button class="btn btn-primary" type="button" (click)="uploadClicked()" [disabled]="formData.attachmentType == null && typeList['SMAttachmentType']?.length > 0">Save</button>
        </div>

        <div *ngIf="triggerDelete" class="col-12" style="color: red; word-wrap: break-word;">
            You are about to delete {{details.Description}}. Continue?
        </div>
        <div *ngIf="triggerDelete" class="col-12" style="text-align: right;margin-top:10px;">
            <button class="btn btn-text-primary" type="button" (click)="resetTriggerDeleteAttachment()">Cancel</button>
            <button class="btn btn-danger" type="button" (click)="deleteAttachmentAndCloseModal()">Delete</button>
        </div>
    </div>
</div>